<template>
  <section :class="assetsClass">
    <p :class="$style.assets__text">{{ assetsString }}</p>
  </section>
</template>

<script setup lang="ts">
import { computed, useCssModule } from 'vue'
import { toYenString, toYenStringWithFirstDecimal } from '../yenScale'

const props = defineProps<{
  row: {
    remainingAssets: number
    deltaYear: number
    events: string[]
  }
}>()

const style = useCssModule()
const assetsClass = computed(() => [
  style.assets,
  {
    [style['assets--lessThanZero']]: props.row.remainingAssets < 0,
  },
])

const assetsString = computed(() => {
  if (Math.abs(props.row.remainingAssets) > 100_000_000) {
    return toYenStringWithFirstDecimal(props.row.remainingAssets)
  }

  return toYenString(props.row.remainingAssets)
})
</script>

<style lang="scss" module>
.assets {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 4px;
  background-color: $color-surface-accent-primary-light;
  color: $color-blue-700;

  &--lessThanZero {
    background-color: $color-caution-surface;
    color: $color-caution-accent;
  }

  &__text {
    text-align: center;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>
